export default function getStyleForType(type) {
    const base = {
        borderRadius: '4px',
        borderWidth: '2px',
        boxSizing: 'border-box',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
    };

    return {
        ...base,
        border: '1px dashed #64748b',
        backgroundColor: 'rgba(100, 116, 139, 0.1)',
    };

    // Optionally: switch-case for types (left as-is for future expansion)
}
